import { render, staticRenderFns } from "./ProductResume.vue?vue&type=template&id=3c5c61b4"
import script from "./ProductResume.vue?vue&type=script&lang=js"
export * from "./ProductResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports